import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';
import './i18n'; // <-- أضف هذا السطر

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);